/**
 * avatars/items/tail.js
 * Xây dựng hình học 3D cho createTail
 */

import * as THREE from 'three';
import { TAIL_TYPES } from './item-types.js';

export { TAIL_TYPES };

export function createTail(lib, type, torsoW, torsoH, torsoD, tailColor = '#b91c1c') {
  const tailGroup = new THREE.Group();
  tailGroup.name = `Tail_${type}`;

  if (!type || type === 'none') return tailGroup;

  const tailMat = new THREE.MeshStandardMaterial({
    color: tailColor,
    roughness: 0.6
  });
  lib.disposables.push(tailMat);

  if (type === 'dragon_tail') {
    // ĐUÔI RỒNG NHIỀU KHỐI UỐN CONG VÚT LÊN
    const seg1Geo = new THREE.BoxGeometry(torsoW * 0.32, 0.16, 0.28);
    const seg1 = new THREE.Mesh(seg1Geo, tailMat);
    seg1.position.set(0, torsoH * 0.08, -torsoD * 0.62);
    seg1.rotation.x = -0.25;
    tailGroup.add(seg1);

    const seg2Geo = new THREE.BoxGeometry(torsoW * 0.24, 0.14, 0.32);
    const seg2 = new THREE.Mesh(seg2Geo, tailMat);
    seg2.position.set(0, torsoH * 0.12, -torsoD * 0.62 - 0.24);
    seg2.rotation.x = -0.1;
    tailGroup.add(seg2);

    const seg3Geo = new THREE.BoxGeometry(torsoW * 0.18, 0.12, 0.28);
    const seg3 = new THREE.Mesh(seg3Geo, tailMat);
    seg3.position.set(0, torsoH * 0.22, -torsoD * 0.62 - 0.48);
    seg3.rotation.x = 0.35;
    tailGroup.add(seg3);

    const tipGeo = new THREE.BoxGeometry(torsoW * 0.26, 0.06, 0.18);
    const tip = new THREE.Mesh(tipGeo, tailMat);
    tip.position.set(0, torsoH * 0.35, -torsoD * 0.62 - 0.62);
    tip.rotation.x = 0.65;
    tailGroup.add(tip);

    lib.disposables.push(seg1Geo, seg2Geo, seg3Geo, tipGeo);
  }

  return tailGroup;
}
